import React from 'react';

interface FlagIconProps {
  countryCode: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export default function FlagIcon({ countryCode, size = 'md', className = '' }: FlagIconProps) {
  const sizeMap = {
    sm: 'w-4 h-3',
    md: 'w-5 h-4', 
    lg: 'w-6 h-5'
  };

  const flagUrl = `https://flagcdn.com/${countryCode.toLowerCase()}.svg`;
  
  return (
    <img
      src={flagUrl}
      alt={`${countryCode} flag`}
      className={`${sizeMap[size]} object-cover rounded-sm ${className}`}
      loading="lazy"
      onError={(e) => {
        // Fallback to text if flag fails to load
        const target = e.target as HTMLImageElement;
        target.style.display = 'none';
        const fallback = document.createElement('span');
        fallback.textContent = countryCode;
        fallback.className = 'text-xs text-white/60 font-mono';
        target.parentNode?.replaceChild(fallback, target);
      }}
    />
  );
} 
 